// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"menu-application"},"children":[{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M4 4H5V5H4V4Z M11.5 4H12.5V5H11.5V4Z M19 4H20V5H19V4Z M19 11.5H20V12.5H19V11.5Z M19 19H20V20H19V19Z M11.5 11.5H12.5V12.5H11.5V11.5Z M11.5 19H12.5V20H11.5V19Z M4 11.5H5V12.5H4V11.5Z M4 19H5V20H4V19Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const MenuApplicationIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'menu-application',
    ref,
    icon: element,
  },
));

MenuApplicationIcon.displayName = 'MenuApplicationIcon';

export default MenuApplicationIcon;
